import { render, staticRenderFns } from "./orderWeeklyDetailItem.vue?vue&type=template&id=117c0734&scoped=true&"
import script from "./orderWeeklyDetailItem.vue?vue&type=script&lang=js&"
export * from "./orderWeeklyDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./orderWeeklyDetailItem.vue?vue&type=style&index=0&id=117c0734&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117c0734",
  null
  
)

export default component.exports